import { rd, type RemoteData } from '@passionware/monads';
import { SchemaError } from './parseWithDecoratedError';

/** The schema error of failed data that still carries unvalidated fallback data. */
function schemaErrorOf(data: RemoteData<unknown>): SchemaError | undefined {
  return rd.isError(data) &&
    data.error instanceof SchemaError &&
    data.error.fallbackData !== undefined
    ? data.error
    : undefined;
}

/**
 * Data that failed only its schema becomes a success with the unvalidated
 * fallback; anything else passes through. Callers render the result knowing
 * it may break the type (inside an error boundary).
 */
function recoverSchemaError<T>(data: RemoteData<T>): RemoteData<T> {
  const error = schemaErrorOf(data);
  return error === undefined ? data : rd.of(error.fallbackData as T);
}

export const schemaErrorFallback = { schemaErrorOf, recoverSchemaError };
